<template>
  <!--导入设置-->
  <div class="app-main-inner app-main-inner-row">
    <el-form label-width="100px" label-position="left" class="section" style="width: 650px;">
      <el-row :gutter="10">
        <el-col :span="24">
          <div style="display: flex">
            <div style="background-color: #57D1FF; width: 12px; height: 30px;margin-right: 5px;" />
            <label style="font-width: bold; font-size: 15px;">{{ $t('SeaExport.importSetting') }}</label>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="isFinance" :gutter="10">
        <el-col :span="24">
          <el-radio-group v-model="bussinessType" no="1" @change="bussinessType_changeHandler">
            <el-radio label="SE" value="SE">{{ $t('CargoMsg.Cargo_OceanExport') }}</el-radio>
            <el-radio label="SI" value="SI">{{ $t('CargoMsg.Cargo_OceanImport') }}</el-radio>
            <el-radio label="AE" value="AE">{{ $t('CargoMsg.Cargo_AirExport') }}</el-radio>
            <el-radio label="AI" value="AI">{{ $t('CargoMsg.Cargo_AirImport') }}</el-radio>
            <el-radio label="RE" value="RE">{{ $t('CargoMsg.Cargo_RailwayExport') }}</el-radio>
            <el-radio label="RI" value="RI">{{ $t('CargoMsg.Cargo_RailwayImport') }}</el-radio>
            <el-radio label="IE" value="IE">{{ $t('CargoMsg.Cargo_IntegratedJob') }}</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="14">
          <el-form-item :label="$t('SeaExport.noRule')">
            <el-select
              v-model="noRule"
              no="2"
              :placeholder="$t('SeaExport.PleaseSelect')"
              size="mini"
            >
              <el-option
                v-for="(item,index) in noRuleList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-radio-group v-model="accountType" no="3">
            <el-radio :label="1">{{ $t('SeaExport.receivable') }}</el-radio>
            <el-radio :label="0">{{ $t('SeaExport.payable') }}</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="14">
          <el-form-item :label="$t('SeaExport.TaxRate')">
            <el-input-number v-model="txtTaxRate" no="4" :controls="false" :min="0" />
          </el-form-item>
        </el-col>
        <el-col v-if="lob === 'RE' && !isFinance" :span="10">
          <el-radio-group v-model="railwayType" no="5">
            <el-radio label="RE">{{ $t('CargoMsg.Cargo_Export') }}</el-radio>
            <el-radio label="RI">{{ $t('CargoMsg.Cargo_JobTypeImport') }}</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>

      <!-- 导入文件-->
      <el-row :gutter="10">
        <el-col :span="24">
          <div style="display: flex">
            <div style="background-color: #57D1FF; width: 12px; height: 30px;margin-right: 5px" />
            <label style="font-width: bold; font-size: 15px;">{{ $t('SeaExport.importFile') }}</label>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="14">
          <el-form-item :label="$t('SeaExport.FileName')">
            <el-input ref="txtFileName" v-model="txtFileName" no="6" :readonly="true" />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <div style="flex: 1">
            <el-upload
              ref="upload"
              :data="{ uploadSetting: uploadSetting }"
              accept=".xls"
              :multiple="false"
              :action="URL.act.charge.importExcelCharge"
              :headers="{sessionId, language}"
              :auto-upload="false"
              :show-file-list="false"
              :on-success="uploadExcelSuccess"
              :on-error="uploadExcelError"
              :on-change="handleChange"
              style="display: inline-block;"
            >
              <el-button type="primary" no="7">{{ $t('SeaExport.SelectFile') }}</el-button>
            </el-upload>

            <el-button type="primary" no="8" style="margin-left: 10px;" @click="downloadTemplate">{{ $t('SeaExport.TemplateDownload') }}</el-button>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="14">
          <div>
            <el-checkbox v-model="onlyImportedCurrentBranch" no="50">{{ $t('CargoMsg.Cargo_OnlyImportedCurrentBranch') }}</el-checkbox>
          </div>
        </el-col>
      </el-row>

      <el-row v-if="isFinance" :gutter="10">
        <el-col :span="14">
          <el-form-item :label="$t('SeaExport.importExpenseStatus')">
            <el-select
              v-model="importExpenseStatus"
              no="9"
              :placeholder="$t('SeaExport.PleaseSelect')"
              size="mini"
            >
              <el-option
                v-for="(item,index) in importExpenseStatusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="isFinance" :gutter="10">
        <el-col :span="14">
          <el-form-item :label="$t('SeaExport.accountingDate')">
            <el-date-picker v-model="accountingDate" type="date" no="10" value-format="yyyy-MM-dd" style="width:195px;" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-button type="primary" no="11" @click="importFileBtnClickHandler">{{ $t('SeaExport.confirmImport') }}</el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      v-if="importResultWindow.visible"
      v-el-drag-dialog
      :visible.sync="importResultWindow.visible"
      :title="importResultWindow.title"
      width="400px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @close="closeHandler"
    >
      <div style="display: flex;flex-direction: column; text-align: center">
        <span style="line-height: 40px;">{{ importResultWindow.content }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" no="12" style="margin-right: 30px;" @click="continueImporting()">{{ $t('SeaExport.ContinueImporting') }}</el-button>
        <el-button :disabled="!importResultWindow.downLoadDocumentId" type="primary" no="13" style="margin-right: 30px;" @click="downloadResultLog()">{{ $t('SeaExport.DownloadResultLog') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import $store from '@/store'

export default {
  name: 'BatchImportCharge',
  components: { cargoAdvanceSelect, cargoCompanySelect },
  props: {
    lob: { type: String, required: true } // 业务类型
  },
  data() {
    return {
      URL,
      SystemConstants,
      selectTypeNames: TYPE_NAMES,
      uploadSetting: '',
      noRuleList: [],
      noRule: '',
      txtFileName: '', // 导入文件名
      txtTaxRate: 0, // 税率
      accountType: 1, // 收付类型 默认 应收
      railwayType: 'RE', // 铁路业务类型 默认 铁出
      bussinessType: 'SE', // 业务类型，默认海出-财务模块使用，业务模块传进来的是lob
      isFinance: false, // 是否财务
      isOverseaEnabled: false, // 是否允许修改费用中国内国外的选项
      importResultWindow: {
        visible: false,
        downLoadDocumentId: '',
        title: '',
        content: ''
      },
      // 导入费用状态默认1：已提交  2：已审核
      importExpenseStatusList: [],
      importExpenseStatus: '',
      accountingDate: '',
      onlyImportedCurrentBranch: false,
      loading: null
    }
  },
  computed: {
    language() {
      switch (this.$store.getters.language) {
        case 'zh':
          return 'zh_CN'
        case 'ja':
          return 'ja_JP'
        default:
          return 'en_US'
      }
    },
    sessionId() {
      return this.$store.getters.token
    }
  },
  watch: {},
  async created() {
    // 是否允许修改导入设置国内国外的选项
    await cache.load(cacheName.CONFIG)
    this.isOverseaEnabled = parseInt(cache.config.get('canChangeOverseaOfCharge')) === 1
  },
  methods: {
    onShow() {
      this.uploadSetting = ''
      this.importResultWindow.downLoadDocumentId = ''
      this.initializeHandler()
    },
    initializeHandler() {
      this.isFinance = this.lob === 'Finance'
      this.lob = (this.lob === 'Finance' ? SystemConstants.SE.code : this.lob)
      if (!this.isFinance) this.getCbNoRuleDataProvider(this.lob)
      this.initImportExpenseStatus()
      this.initializeSetting()
      if (this.isFinance) {
        const noRule = this.noRule
        this.getCbNoRuleDataProvider(this.lob)
        this.noRule = noRule
      }
    },
    // 初始化导入后费用状态下拉框 仅财务模块
    initImportExpenseStatus() {
      if (!this.isFinance) return
      const importExpenseStatusArr = []
      importExpenseStatusArr.push({ label: this.$t('Message.Submitted'), value: '1' })
      importExpenseStatusArr.push({ label: this.$t('Message.Approved'), value: '2' })
      this.importExpenseStatus = importExpenseStatusArr[0].value
      this.importExpenseStatusList = importExpenseStatusArr
    },
    // 初始化编号规则下拉框
    getCbNoRuleDataProvider(jobType) {
      const cbNoRuleArr = []
      if (SystemConstants.AE.code === jobType) {
        cbNoRuleArr.push({ label: this.$t('SeaExport.JobNo'), value: '0' })
        cbNoRuleArr.push({ label: 'MAWB NO', value: '1' })
        cbNoRuleArr.push({ label: this.$t('SeaExport.CustomerReferenceNumber'), value: '2' })
      } else if (SystemConstants.AI.code === jobType) {
        cbNoRuleArr.push({ label: this.$t('Payment.businessNumber'), value: '0' })
        cbNoRuleArr.push({ label: this.$t('Payment.mbl'), value: '1' })
        cbNoRuleArr.push({ label: this.$t('SeaExport.CustomerReferenceNumber'), value: '2' })
      } else if (SystemConstants.RE.code === jobType || SystemConstants.RI.code === jobType) {
        cbNoRuleArr.push({ label: this.$t('Payment.businessNumber'), value: '0' })
        cbNoRuleArr.push({ label: this.$t('Payment.businessReferenceNumber'), value: '1' })
      } else if (SystemConstants.SI.code === jobType) {
        cbNoRuleArr.push({ label: this.$t('Payment.businessNumber'), value: '0' })
        cbNoRuleArr.push({ label: 'MBL NO', value: '1' })
        cbNoRuleArr.push({ label: this.$t('SeaExport.CustomerReferenceNumber'), value: '2' })
      } else if (SystemConstants.IE.code === jobType) {
        cbNoRuleArr.push({ label: this.$t('Payment.businessNumber'), value: '0' })
        cbNoRuleArr.push({ label: this.$t('Payment.businessReferenceNumber'), value: '1' })
      } else {
        cbNoRuleArr.push({ label: this.$t('Payment.businessNumber'), value: '0' })
        cbNoRuleArr.push({ label: 'MBL NO', value: '1' })
        cbNoRuleArr.push({ label: this.$t('Payment.businessReferenceNumber'), value: '2' })
      }
      this.noRule = cbNoRuleArr[0].value
      this.noRuleList = cbNoRuleArr
    },
    // 从缓存里面加载导入设置
    initializeSetting() {
      // 从缓存里取导入设置
      const importSettingKey = 'IMPORTSETTING_' + (this.isFinance ? 'Finance' : this.lob)
      const setting = LocalStorageUtils.getConfiguration(importSettingKey)
      if (setting) {
        this.noRule = setting.noRule
        this.accountType = setting.accountType
        this.txtTaxRate = setting.taxRate
        this.lob = this.bussinessType = setting.lob || 'SE'
        this.onlyImportedCurrentBranch = setting.onlyImportedCurrentBranch
        if (this.isFinance) this.accountingDate = setting.accountingDate
        if (this.isFinance) this.importExpenseStatus = setting.importExpenseStatus
        if (!this.isFinance && (this.lob === 'RE' || this.lob === 'RI')) this.railwayType = setting.railwayType // 铁路进口使用
      }
    },
    // 确认导入
    importFileBtnClickHandler() {
      this.loading = getLoading()
      // 验证导入设置必填
      if (!this.checkNotNull()) {
        this.loading.close()
        return
      }
      // 保存导入设置到缓存
      const setting = {}
      setting.noRule = this.noRule
      setting.accountType = this.accountType
      setting.taxRate = this.txtTaxRate || 0
      setting.lob = this.isFinance ? this.bussinessType : this.lob
      setting.onlyImportedCurrentBranch = this.onlyImportedCurrentBranch
      if (!this.isFinance && (this.lob === 'RE' || this.lob === 'RI')) setting.railwayType = this.railwayType // 铁路进口使用
      setting.branchId = $store.getters.currentOfficeId // 当前分公司ID
      setting.canChangeOverseaOfCharge = parseInt(cache.config.get('canChangeOverseaOfCharge'))// 国内/国外
      setting.openSapConfig = parseInt(cache.config.get('openSapConfig'))// 是否开启SAP交单
      if (this.isFinance) setting.isFinance = this.isFinance // 如果是财务导入，则传入此标志
      const importSettingKey = 'IMPORTSETTING_' + (this.isFinance ? 'Finance' : this.lob)
      if (this.isFinance) setting.accountingDate = this.accountingDate
      if (this.isFinance) setting.importExpenseStatus = this.importExpenseStatus
      LocalStorageUtils.setConfiguration(importSettingKey, setting)

      const uploadFiles = this.$refs.upload.uploadFiles
      // this.$logger.log('uploadFiles=======确认导入', uploadFiles)
      if (uploadFiles && uploadFiles.length > 0 && setting) {
        const file = uploadFiles[uploadFiles.length - 1]
        setting.fileName = this.txtFileName
        setting.size = file.size
        if (this.txtFileName.indexOf('.') > -1) {
          const arr = this.txtFileName.split('.')
          setting.type = arr[arr.length - 1].toLowerCase()
        }
        setting.officeId = this.$store.getters.currentOfficeId
        setting.departId = this.$store.getters.currentDeptId
        this.uploadSetting = JSON.stringify(setting)
        setTimeout(() => {
          this.$refs.upload.submit()
        }, 1000)
      }
    },
    // 验证必填项
    checkNotNull() {
      if (this.noRule < 0) {
        this.$message.warning(this.$t('Message.numberingRuleCannotBeEmpty'))
        return false
      }
      if (this.accountType !== 0 && this.accountType !== 1) {
        this.$message.warning(this.$t('Message.RevenueTypeCannotBeBlank'))
        return false
      }
      if (this.txtTaxRate && isNaN(parseInt(this.txtTaxRate))) {
        this.$message.warning(this.$t('Message.IncorrectFormatOnlyIntegerSupported'))
        return false
      }
      if (!this.txtFileName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return false
      }
      // 校验 审核状态为已审核时：财务日期不能为空 不能大于当前日期
      if (this.isFinance && this.importExpenseStatus === '2') {
        if (this.accountingDate == null || this.accountingDate.length < 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_FinancialDateCheckNull'))
          return false
        }
        var curDate = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
        if (this.accountingDate > curDate) {
          this.$message.warning(this.$t('CargoMsg.Cargo_FinancialDateCheckBefore'))
          return false
        }
      }
      return true
    },
    // 导入成功
    uploadExcelSuccess(response, file, fileList) {
      if (this.loading) {
        this.loading.close()
      }
      const result = response.data
      const errors = response.errors || []
      if (!result && errors && errors.length > 0) {
        const errorMsg = errors[0].message
        this.$message.error(errorMsg)
        return
      }
      if (result) {
        if (result.message) {
          this.$confirm(result.message, this.$t('Message.Prompt'), { type: 'warning', closeOnClickModal: false, showCancelButton: false }).finally(() => {
            this.closeHandler()
          })
          return
        }
        if (result.rowNum && result.resultDocumentId) {
          const successNum = result.successNum
          const allNum = result.rowNum
          this.importResultWindow.downLoadDocumentId = result.resultDocumentId
          this.importResultWindow.title = this.$t('SeaExport.ImportComplete')
          this.importResultWindow.content = `${this.$t('Message.Success')}【${successNum}】${this.$t('CargoMsg.Cargo_Pcst')}，${this.$t('Message.Failure')}【${allNum - successNum}】${this.$t('CargoMsg.Cargo_Pcst')}。`
          this.importResultWindow.visible = true
        } else {
          this.importResultWindow.downLoadDocumentId = ''
          this.importResultWindow.title = this.$t('Message.ImportFailed')
          this.importResultWindow.content = `${this.$t('CargoMsg.Cargo_UploadFailedCheckExcel')}`
          this.importResultWindow.visible = true
        }
      }
    },
    uploadExcelError() {
      if (this.loading) {
        this.loading.close()
      }
    },
    // 继续导入
    continueImporting() {
      this.closeHandler()
      // 初始化导入设置
      // this.initializeSetting()
    },
    closeHandler() {
      this.$refs.upload.clearFiles()
      this.txtFileName = ''
      this.importResultWindow.visible = false
    },
    // 下载导入结果
    downloadResultLog() {
      this.closeHandler()
      // 从云存储上下载文件
      if (!this.importResultWindow.downLoadDocumentId) {
        this.$message.warning(this.$t('SeaExport.NoCorrespondingFile'))
        return
      }
      const storageURL = cache.config.get('StorageURL')
      const url = `${URL.common.findByFileId}/${this.importResultWindow.downLoadDocumentId}?sessionId=${this.sessionId}`
      window.open(url)
    },
    handleChange(file, fileList) {
      if (fileList && fileList.length > 1) {
        // 清空所有文件
        this.$refs.upload.clearFiles()
        // 重新添加当前文件
        this.$refs.upload.handleStart(file.raw)
      }
      this.txtFileName = file.name || ''
    },
    // 下载模板
    downloadTemplate() {
      const office = $store.getters.currentOffice
      if (this.$store.getters.language === 'zh') {
        if (office && office.whtTaxMode) {
          ExportUtils.downloadTemplateFile('MonthCostTemplate-WHT.xls', 'charge')
        } else {
          ExportUtils.downloadTemplateFile('MonthCostTemplate.xls', 'charge')
        }
      } else {
        if (office && office.whtTaxMode) {
          ExportUtils.downloadTemplateFile('MonthCostTemplate(EN)-WHT.xls', 'charge')
        } else {
          ExportUtils.downloadTemplateFile('MonthCostTemplate(EN).xls', 'charge')
        }
      }
    },
    // 业务类型 改变
    bussinessType_changeHandler() {
      this.getCbNoRuleDataProvider(this.bussinessType)
    }
  }
}
</script>

<style scoped>

</style>
